<ng-container *ngIf="formControl; then formDropdown; else simpleDropdown"></ng-container>

<ng-template #formDropdown>
  <mat-form-field>
    <mat-label class="label">{{label}}</mat-label>
    <mat-select [placeholder]="placeholder"
                [formControl]="formControl"
                [compareWith]="compareFn"
                (selectionChange)="onSelectionChange($event)">
      <mat-option *ngIf="showNoneOption">{{ noneOptionLabel | translate }}</mat-option>
      <mat-option *ngFor="let item of items"
                  [value]="item">{{ item[displayField] | translate }}</mat-option>
    </mat-select>
    <mat-icon matSuffix class="select-arrow-icon">expand_more</mat-icon>
  </mat-form-field>
  <app-form-error-list *ngIf="showErrors"
                       [errorMap]="formControl.errors">
  </app-form-error-list>
</ng-template>

<ng-template #simpleDropdown>
  <mat-form-field>
    <mat-label class="label">{{label}}</mat-label>
    <mat-select [placeholder]="placeholder"
                [value]="value"
                [compareWith]="compareFn"
                [disabled]="isDisabled"
                (selectionChange)="onSelectionChange($event)">
      <mat-option *ngIf="showNoneOption">{{ noneOptionLabel | translate }}</mat-option>
      <mat-option *ngFor="let item of items"
                  [value]="item">{{ item[displayField] | translate }}</mat-option>
    </mat-select>
    <mat-icon matSuffix class="select-arrow-icon">expand_more</mat-icon>
  </mat-form-field>
</ng-template>
